import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  AddressWrapper: styled(Flex, {
    gap: '$2',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '@desktop': {
      justifyContent: 'start',
    },
  }),
};

export default styles;
